import { useEffect } from "react"
import { useUptimeConfigQuery } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import { setCachedStatusConfig } from "@/v2-backoffice-client/uptime/uptime.statusConfigCache"

// useUptimeStatusConfigBootstrap subscribes to `getStatusConfig`
// and pushes the result into the module-level cache that the
// synchronous helpers in `uptime.utils.ts` read from. Mount it
// once at the top of every uptime entry point (UptimePage and
// UptimeDashboardView) so the helpers stay populated whenever an
// uptime surface is visible without having to thread a provider
// through every component.
//
// Apollo handles the deduplication: multiple call sites mounting
// this hook share the same in-flight request and the same cached
// result, so this is cheap to over-mount.
export function useUptimeStatusConfigBootstrap(): void {
  const { data } = useUptimeConfigQuery({
    fetchPolicy: "cache-first",
  })

  useEffect(() => {
    setCachedStatusConfig(data?.getStatusConfig ?? null)
  }, [data])
}
